export const environment = {
  production: false,
  apiUrl: 'https://dev.projeto.saudeconectada.cists.com.br/backend',
  cindiKind: 'equilibria',
};
